export function assertUnreachable(_x) {
    throw new Error("Unreachable code.");
}
export function deepFreeze(object) {
    const propNames = Object.getOwnPropertyNames(object);
    for (const name of propNames) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const value = object[name];
        if (value && typeof value === "object") {
            deepFreeze(value);
        }
    }
    return Object.freeze(object);
}
export function isDefined(value) {
    return !!value;
}
export function discriminate(discriminantKey, discriminantValue) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (object) => object[discriminantKey] === discriminantValue;
}
export function asMutable(t) {
    return t;
}
/**
 * Redefines an object property as writable
 *
 * Usually, ReadOnly<T> is only enforced at the type level, however in some cases an object's property may have been
 * defined as non-writable. So, we try to redefine the property we're interested in as writable.
 *
 * However, the property may have also been defined as non-configurable as well, in which case we'll get a TypeError
 * when we try to redefine it. In this case, the only thing that's left to us is to do a clone, making all properties
 * writable.
 */
export function forceMutableProperty(t, k) {
    try {
        Object.defineProperty(t, k, { writable: true });
    }
    catch (error) {
        if (error.constructor.name === "TypeError") {
            return { ...t };
        }
        throw error;
    }
    return t;
}
//# sourceMappingURL=TypeHelpers.js.map